import strFunc from '@/lib/lyg/string';

export interface HeadMenuRow {
  key: string;
  name: string;
  url: string;
  msg: string;
  isShow: boolean;
  ico?: string;
  ico_active?: string;
}
export interface SubMenuRow {
  key: string;
  name: string;
  url: string;
  msg: string;
  hmenu: string;
  isShow: boolean;
  first_subkey: string;
}

const d_smenu_row: SubMenuRow = {
  key: "",
  name: "",
  url: "",
  msg: "",
  hmenu: "",
  isShow: false,
  first_subkey: "",
};

export const hmenu: HeadMenuRow[] = [
  { key: "h_student", name: "원생관리", url: "/comp/basic/student/list", msg: "", isShow: true },
  { key: "h_eval", name: "수업평가", url: "/comp/edu/eval/card_list", msg: "", isShow: false },
  { key: "h_prescribe", name: "학습처방", url: "/comp/edu/daily_report/card_list", msg: "", isShow: true },
  { key: "h_plan", name: "맞춤플랜", url: "/comp/plan/todo/stu_card_list", msg: "", isShow: true },
  { key: "h_video", name: "동영상강의", url: "/comp/plan/video/corse/list", msg: "", isShow: false },
  { key: "h_attend", name: "출결관리", url: "/comp/edu/attend/list_card", msg: "", isShow: false },
  { key: "h_desk", name: "시간표&좌석", url: "/comp/edu/lecture/list_one_day", msg: "", isShow: true },
  { key: "h_lecture", name: "수업관리", url: "/comp/plan/coolen/move_page", msg: "", isShow: true },
  { key: "h_bridge_en", name: "브릿지잉글리시", url: "/comp/plan/coolen/move_page", msg: "", isShow: false },
  { key: "h_supply", name: "수납관리", url: "/comp/supply/main", msg: "", isShow: true },
  { key: "h_sms", name: "문자&알림톡", url: "/comp/basic/sms/list", msg: "", isShow: true },
  { key: "h_setting", name: "환경설정", url: "/comp/basic/corp/main", msg: "", isShow: false },
  { key: "h_etc_setting", name: "기타설정", url: "/comp/basic/log_login/list", msg: "", isShow: false },
  { key: "h_book_order", name: "교재주문", url: "/comp/book_order/book_order_use/list", msg: "", isShow: true },
  { key: "h_comp_rx", name: "학습처방학회", url: "/comp/edu/comp_stu_prescribe/manage/list", msg: "", isShow: false },
];
export const smenu: SubMenuRow[] = [
  { ...d_smenu_row, key: "basic_main", name: "메인", url: "/comp", msg: "", hmenu: "main", isShow: false },

  { ...d_smenu_row, key: "init_test_main", name: "진단테스트", url: "/comp/init_test/main", msg: "", hmenu: "h_init_test", isShow: true },

  { ...d_smenu_row, key: "coolen_move", name: "브릿지 영어", url: "/comp/plan/coolen/move_page", msg: "", hmenu: "h_lecture", isShow: true },
  { ...d_smenu_row, key: "plan_math_main", name: "수앤탐수학", url: "/comp/plan_math/main", msg: "", hmenu: "h_lecture", isShow: true },
  { ...d_smenu_row, key: "plan_math_basic_make", name: "연산PT", url: "/comp/plan_math/basic/make_list", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "plan_math_program_link", name: "Program", url: "/comp/plan_math/program/link_page", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "study_map_main", name: "교과맵핑", url: "/comp/study/study_map/main", msg: "", hmenu: "h_lecture", isShow: true },
  { ...d_smenu_row, key: "study_map_stu", name: "학생별맵핑", url: "/comp/study/study_map/stu_map", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "study_map_study_title", name: "교재별맵핑", url: "/comp/study/study_map/title_map", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "study_map_history", name: "이력", url: "/comp/study/study_map/history", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "plan_video_list_union", name: "동영상강의", url: "/comp/plan/video/list_union", msg: "", hmenu: "h_lecture", isShow: true },
  { ...d_smenu_row, key: "word_inside_list", name: "브릿지인사이드", url: "/comp/plan/word/word_inside/list", msg: "", hmenu: "h_lecture", isShow: false },
  { ...d_smenu_row, key: "word_inside_share", name: "브릿지인사이드 공유", url: "/comp/plan/word/word_inside/share", msg: "", hmenu: "h_lecture", isShow: false },

  { ...d_smenu_row, key: "textbook_stu_use_list", name: "브릿지영어", url: "/comp/book_order/comp_textbook/stu_use_list", msg: "", hmenu: "h_bridge_en", isShow: false },
  { ...d_smenu_row, key: "comp_textbook_list_view", name: "브릿지영어", url: "/comp/book_order/comp_textbook/textbook_list_view", msg: "", hmenu: "h_bridge_en", isShow: true },

  { ...d_smenu_row, key: "student_list_new", name: "신규원생관리", url: "/comp/basic/student/list_new", msg: "", hmenu: "h_student", isShow: false },
  { ...d_smenu_row, key: "student_list", name: "원생관리", url: "/comp/basic/student/list", msg: "", hmenu: "h_student", isShow: true },
  { ...d_smenu_row, key: "student_list_view", name: "원생관리상세", url: "/comp/basic/student/list_view", msg: "", hmenu: "h_student", isShow: false, first_subkey: "student_list" },
  { ...d_smenu_row, key: "counsel_calendar", name: "상담관리", url: "/comp/basic/counsel/calendar", msg: "", hmenu: "h_student", isShow: true },
  { ...d_smenu_row, key: "counsel_list", name: "상담관리", url: "/comp/basic/counsel/list", msg: "", hmenu: "h_student", isShow: false, first_subkey: "counsel_calendar" },
  { ...d_smenu_row, key: "counsel_history_list", name: "상담이력", url: "/comp/basic/counsel/history_list", msg: "", hmenu: "h_student", isShow: false, first_subkey: "counsel_calendar" },
  { ...d_smenu_row, key: "attend_main", name: "출결관리", url: "/comp/edu/attend/main", msg: "", hmenu: "h_student", isShow: true },
  { ...d_smenu_row, key: "counsel_career", name: "RUTA상담", url: "/comp/basic/counsel/career", msg: "", hmenu: "h_student", isShow: false },
  // {key:"class_stu_list",name:"클래스별학생",url:"/comp/edu/class_stu/list",msg:"",hmenu:"h_student",isShow:true},

  { ...d_smenu_row, key: "sms_list", name: "문자", url: "/comp/basic/sms/list", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "sms_sender_list", name: "발신번호", url: "/comp/basic/sms_sender/list", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "sms_sender_help", name: "도움말", url: "/comp/basic/sms_sender/help", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "push_list", name: "푸시이력", url: "/comp/basic/push/list", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "katalk_msg_opt", name: "알림톡옵션", url: "/comp/basic/katalk/msg_opt", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "katalk_list", name: "알림톡이력", url: "/comp/basic/katalk/list", msg: "", hmenu: "h_sms", isShow: true },
  { ...d_smenu_row, key: "point_use_list", name: "포인트사용이력", url: "/comp/basic/point/point_use_list", msg: "", hmenu: "h_sms", isShow: true },

  { ...d_smenu_row, key: "eval_card_list", name: "수업평가서", url: "/comp/edu/eval/card_list", msg: "", hmenu: "h_eval", isShow: true },
  { ...d_smenu_row, key: "eval_form_list", name: "평가폼작성", url: "/comp/edu/eval_from/list", msg: "", hmenu: "h_eval", isShow: false },
  { ...d_smenu_row, key: "eval_history_list", name: "수업평가이력", url: "/comp/edu/eval_history/list", msg: "", hmenu: "h_eval", isShow: true },

  { ...d_smenu_row, key: "discover_map_list", name: "디스커버리맵", url: "/comp/edu/discover_map/list", msg: "", hmenu: "h_prescribe", isShow: false },
  { ...d_smenu_row, key: "discover_map_history_list", name: "디커맵이력", url: "/comp/edu/discover_map/history_list", msg: "", hmenu: "h_prescribe", isShow: false },
  { ...d_smenu_row, key: "discover_map_calendar", name: "학습처방", url: "/comp/edu/discover_map/list_calendar", msg: "", hmenu: "h_prescribe", isShow: true },
  // { ...d_smenu_row, key: "month_prescribe_calendar", name: "학습처방", url: "/comp/edu/month_prescribe/calendar", msg: "", hmenu: "h_prescribe", isShow: true },
  { ...d_smenu_row, key: "daily_report_card_list", name: "데일리플랜", url: "/comp/edu/daily_report/card_list", msg: "", hmenu: "h_prescribe", isShow: true },
  // {key:"month_prescribe_list",name:"월간학습처방",url:"/comp/edu/month_prescribe/list",msg:"",hmenu:"h_prescribe",isShow:true},
  { ...d_smenu_row, key: "study_stu_progress_manage", name: "개별진도", url: "/comp/plan/study/stu_progress/manage", msg: "", hmenu: "h_prescribe", isShow: true },
  { ...d_smenu_row, key: "study_diary_list", name: "디스커버리", url: "/comp/basic/study_diary/list", msg: "", hmenu: "h_prescribe", isShow: false },
  { ...d_smenu_row, key: "tstu_todo_list", name: "플랜보드", url: "/comp/tea/tstu_todo/list", msg: "", hmenu: "h_prescribe", isShow: true },
  { ...d_smenu_row, key: "daily_report_history", name: "데일리플랜이력", url: "/comp/edu/daily_report/history_list", msg: "", hmenu: "h_prescribe", isShow: false },
  { ...d_smenu_row, key: "daily_prescribe_history", name: "처방이력", url: "/comp/edu/daily_prescribe/history", msg: "", hmenu: "h_prescribe", isShow: false },

  { ...d_smenu_row, key: "study_prescribe_card_list", name: "학습처방", url: "/comp/edu/study_prescribe/card_list", msg: "", hmenu: "h_prescribe", isShow: false },
  { ...d_smenu_row, key: "study_prescribe_his_list", name: "학습처방이력", url: "/comp/edu/study_prescribe/history_list", msg: "", hmenu: "h_prescribe", isShow: false },

  { ...d_smenu_row, key: "comp_stu_prescribe_list", name: "학습처방", url: "/comp/edu/comp_stu_prescribe/manage/list", msg: "", hmenu: "h_comp_rx", isShow: true },

  { ...d_smenu_row, key: "study_title_list_union", name: "학습절차", url: "/comp/study/study/list_union", msg: "", hmenu: "h_plan", isShow: true },
  { ...d_smenu_row, key: "todo_stu_card", name: "맞춤플랜", url: "/comp/plan/todo/stu_card_list", msg: "", hmenu: "h_plan", isShow: true },
  { ...d_smenu_row, key: "plan_main", name: "한달플랜", url: "/comp/plan/calendar", msg: "", hmenu: "h_plan", isShow: true },
  { ...d_smenu_row, key: "plan_make_todo", name: "플랜작성", url: "/comp/plan/todo/make_todo", msg: "", hmenu: "h_plan", isShow: true },
  { ...d_smenu_row, key: "stu_todo_list", name: "맞춤플랜이력", url: "/comp/plan/todo/stu_todo/list", msg: "", hmenu: "h_plan", isShow: true },
  //{key:"routin_list",name:"루틴관리",url:"/comp/plan/study/routine/list",msg:"",hmenu:"h_plan",isShow:true},
  { ...d_smenu_row, key: "study_list", name: "교재관리", url: "/comp/plan/study/study/list", msg: "", hmenu: "h_plan", isShow: false },
  // {key:"study_subject_list",name:"과목구분",url:"/comp/plan/study/subject/list",msg:"",hmenu:"h_plan",isShow:true},
  { ...d_smenu_row, key: "study_share_list", name: "교재공유", url: "/comp/plan/study/share/list", msg: "", hmenu: "h_plan", isShow: false },
  { ...d_smenu_row, key: "todo_dailyc_month_list", name: "월별완료이력", url: "/comp/plan/todo_dailyc/month_list", msg: "", hmenu: "h_plan", isShow: false },

  { ...d_smenu_row, key: "plan_video_corse_list", name: "동영상강의", url: "/comp/plan/video/corse/list", msg: "", hmenu: "h_video", isShow: true },
  // {key:"plan_video_category_list",name:"카테고리",url:"/comp/plan/video/category/list",msg:"",hmenu:"h_video",isShow:true},
  { ...d_smenu_row, key: "plan_video_request_list", name: "신청보기", url: "/comp/plan/video/request/list", msg: "", hmenu: "h_video", isShow: true },
  { ...d_smenu_row, key: "video_use_detail_history", name: "사용이력", url: "/comp/plan/video/use_detail_history/list", msg: "", hmenu: "h_video", isShow: true },
  { ...d_smenu_row, key: "plan_video_share_corse", name: "공유동영상강의", url: "/comp/plan/video/corse_share/list", msg: "", hmenu: "h_video", isShow: true },

  { ...d_smenu_row, key: "attend_card", name: "출결지도", url: "/comp/edu/attend/list_card", msg: "", hmenu: "h_attend", isShow: true },

  { ...d_smenu_row, key: "supply_main", name: "수납관리", url: "/comp/supply/main", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "supply_multy_add", name: "수납생성", url: "/comp/supply/multy_add", msg: "", hmenu: "h_supply", isShow: false },
  // {key:"pos_card_list",name:"카드결제내역",url:"/comp/supply/pos/card/list",msg:"",hmenu:"h_supply",isShow:true},
  // {key:"cash_receipt_list",name:"현금영수증내역",url:"/comp/supply/pos/cash_receipt/list",msg:"",hmenu:"h_supply",isShow:true},
  { ...d_smenu_row, key: "class_list", name: "클래스관리", url: "/comp/edu/class/list", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "simple_trade_list", name: "거래내역(원생)", url: "/comp/supply/simple_trade/list", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "simple_trade_money", name: "입출금", url: "/comp/supply/simple_trade/list_money", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "trade_fix_list", name: "지출내역", url: "/comp/supply/trade_fix/list", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "payt_supply_list", name: "청구발송이력", url: "/comp/payt/payt_supply/list", msg: "", hmenu: "h_supply", isShow: true },
  { ...d_smenu_row, key: "payt_cash_list", name: "현금영수증이력", url: "/comp/payt/payt_cash/list", msg: "", hmenu: "h_supply", isShow: true },

  { ...d_smenu_row, key: "attend_stat", name: "월별통계", url: "/comp/edu/attend/stat_month", msg: "", hmenu: "h_desk", isShow: false },
  { ...d_smenu_row, key: "lecture_one_day", name: "시간표", url: "/comp/edu/lecture/list_one_day", msg: "", hmenu: "h_desk", isShow: true },
  { ...d_smenu_row, key: "list_one_day2", name: "시간표", url: "/comp/edu/lecture/list_one_day2", msg: "", hmenu: "h_desk", isShow: false },
  { ...d_smenu_row, key: "one_week_by_stu", name: "시간표(학생)", url: "/comp/edu/lecture/view_time_table/one_week_by_stu", msg: "", hmenu: "h_desk", isShow: false },
  { ...d_smenu_row, key: "desk_main", name: "좌석설정", url: "/comp/edu/desk/main", msg: "", hmenu: "h_desk", isShow: false },
  { ...d_smenu_row, key: "desk_main2", name: "좌석설정", url: "/comp/edu/desk/desk_plan", msg: "", hmenu: "h_desk", isShow: true },
  //{key:"view_time_table_teacher",name:"시간표(학생)",url:"/comp/edu/lecture/view_time_table/one_week_by_teacher",msg:"",hmenu:"h_desk",isShow:true},
  // { ...d_smenu_row, key: "lecture_list", name: "수업관리", url: "/comp/edu/lecture/list", msg: "", hmenu: "h_desk", isShow: true },
  // {key:"lecture_stu_list",name:"수업수강생",url:"/comp/edu/lecture/lecture_user_time",msg:"",hmenu:"h_desk",isShow:true},
  { ...d_smenu_row, key: "eroom_list", name: "강의실관리", url: "/comp/edu/room/list", msg: "", hmenu: "h_desk", isShow: true },
  { ...d_smenu_row, key: "desk_use_history", name: "좌석 사용이력", url: "/comp/edu/desk/use_list", msg: "", hmenu: "h_desk", isShow: false },
  { ...d_smenu_row, key: "desk_room_view_popup", name: "강의실책상보기팝업", url: "/comp/edu/desk/popup/view_room_popup", msg: "", hmenu: "h_desk", isShow: false },

  { ...d_smenu_row, key: "corp_main", name: "학원정보", url: "/comp/basic/corp/main", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "sys_notice_list", name: "공지", url: "/comp/board/system_notice/list", msg: "", hmenu: "h_setting", isShow: true },
  //{key:"notice_list",name:"공지",url:"/comp/board/notice/list",msg:"",hmenu:"h_setting",isShow:true},
  { ...d_smenu_row, key: "par_notice_list", name: "학부모알림장", url: "/comp/board/par_notice/list", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "user_staff_list", name: "직원관리", url: "/comp/basic/user_staff/list", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "student_list_multy", name: "원생일괄수정", url: "/comp/basic/student/list_multy", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "stu_up_grade", name: "학년진급", url: "/comp/basic/student/stu_up_grade", msg: "", hmenu: "h_setting", isShow: true },
  // {key:"friend_sites",name:"관련 사이트",url:"/comp/edu/site/main",msg:"",hmenu:"h_setting",isShow:true},
  { ...d_smenu_row, key: "parent_list", name: "학부모", url: "/comp/basic/parent/list", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "user_removed_list", name: "삭제회원이력", url: "/comp/basic/user_removed/list", msg: "", hmenu: "h_setting", isShow: true },
  { ...d_smenu_row, key: "site_map", name: "사이트맵", url: "/comp/site_map", msg: "", hmenu: "h_setting", isShow: false },
  { ...d_smenu_row, key: "data_main", name: "자료실", url: "/comp/board/data_main", msg: "", hmenu: "h_setting", isShow: false },
  { ...d_smenu_row, key: "mypage", name: "마이페이지", url: "/comp/mypage", msg: "", hmenu: "main", isShow: false },

  { ...d_smenu_row, key: "book_order_use_list", name: "교재주문", url: "/comp/book_order/book_order_use/list", msg: "", hmenu: "h_book_order", isShow: true },
  { ...d_smenu_row, key: "book_order_comp_list", name: "주문이력", url: "/comp/book_order/shop/order/comp_book_list", msg: "", hmenu: "h_book_order", isShow: false },
  { ...d_smenu_row, key: "book_order_main", name: "주문내역", url: "/comp/book_order/shop/order/book_list", msg: "", hmenu: "h_book_order", isShow: false },
  { ...d_smenu_row, key: "textbook_list", name: "교재", url: "/comp/book_order/textbook/list", msg: "", hmenu: "h_book_order", isShow: false },

  { ...d_smenu_row, key: "log_login_list", name: "로그인로그", url: "/comp/basic/log_login/list", msg: "", hmenu: "h_etc_setting", isShow: true },
  { ...d_smenu_row, key: "login_other", name: "로그인", url: "/comp/login_other", msg: "", hmenu: "h_etc_setting", isShow: true },
  { ...d_smenu_row, key: "sort_custom_list", name: "구분", url: "/comp/basic/sort_custom/list", msg: "", hmenu: "h_etc_setting", isShow: true },
];
export const hmenu_master_arr: string[] = [
  "h_supply"
];
export const smenu_master_arr: string[] = [
  "supply_main",
  "supply_multy_add",
  "pos_card_list",
  "cash_receipt_list",
  "simple_trade_list",
  "sort_custom_list",
  "user_staff_list",
  "log_login_list",
  "user_removed_list",

  "lecture_list",
  "lecture_stu_list",
  "eroom_list",
];
export const hmenu_plani_key_arr: string[] = [
  "h_student",
  "h_prescribe",
  "h_plan",
  "h_lecture",
  "h_desk",
  "h_supply",
  "h_sms",
  "h_book_order",
];
export const smenu_plani_except_arr: string[] = [
  "study_list", "study_share_list"
];
export const smenu_sntbr_except_arr: string[] = [

];
export const smenu_growple_except_arr: string[] = [
  "coolen_move",
  "plan_math_main",
  "study_map_main"
];

export const smenu_main_key_arr: string[] = [
  "book_order_main",
  "textbook_list"
];

export const get_hmenu_arr = (inData: any) => {
  let opt_obj = {
    user_grade: "",
    comp_sort_detail: "",//plani
    is_main: false,
    user: {},
    ...inData
  };
  let user = opt_obj.user;
  let user_grade = opt_obj.user_grade;
  let comp_sort_detail = opt_obj.comp_sort_detail;
  let rs_hmenu_arr: HeadMenuRow[] = [...hmenu];
  for (let i = 0; i < rs_hmenu_arr.length; i++) {
    rs_hmenu_arr[i] = { ...rs_hmenu_arr[i] };
  }

  //순서대로 재배열
  let tmp_change_hmenu_arr: any = [];
  let is_change_hmenu = false;

  if (comp_sort_detail == "plani") {
    is_change_hmenu = true;
    tmp_change_hmenu_arr = [...hmenu_plani_key_arr];
  } else if (comp_sort_detail == "growple") {
    for (let h_i = 0; h_i < rs_hmenu_arr.length; h_i++) {
      let tmp_hmenu = rs_hmenu_arr[h_i];
      if (tmp_hmenu.key == "h_book_order") {
        if (user.is_use_book_order != "1") {
          rs_hmenu_arr[h_i].isShow = false;
        }
      } else if (tmp_hmenu.key == "h_lecture") {
        rs_hmenu_arr[h_i].url = "/comp/study/study/list_union";
      }
    }
  } else if (comp_sort_detail == "prescribe_manage") {
    for (let h_i = 0; h_i < rs_hmenu_arr.length; h_i++) {
      let tmp_hmenu = rs_hmenu_arr[h_i];
      if (tmp_hmenu.key == "h_comp_rx") {
        rs_hmenu_arr[h_i].isShow = true;
      }
    }
  }
  if (is_change_hmenu) {
    let new_hmenu_arr: HeadMenuRow[] = [];
    for (let h_i = 0; h_i < tmp_change_hmenu_arr.length; h_i++) {
      let h_key = tmp_change_hmenu_arr[h_i];
      for (let i = 0; i < rs_hmenu_arr.length; i++) {
        let item = rs_hmenu_arr[i];
        if (item.key == h_key) {
          item.isShow = true;
          new_hmenu_arr.push(item);
        }
      }
    }
    rs_hmenu_arr = new_hmenu_arr;
  }

  //master체크
  for (let i = 0; i < rs_hmenu_arr.length; i++) {
    let item = rs_hmenu_arr[i];
    if (user_grade != "master") {
      if (strFunc.str_in_array(item.key, hmenu_master_arr) != -1) {
        rs_hmenu_arr[i].isShow = false;
      }
    }
  }

  return rs_hmenu_arr;
};
export const get_smenu_arr = (inData: any) => {
  let opt_obj = {
    user_grade: "",
    comp_sort_detail: "",//plani
    user: {},
    is_main: false,
    ...inData
  };
  let user_grade = opt_obj.user_grade;
  let comp_sort_detail = opt_obj.comp_sort_detail;
  let user = opt_obj.user;
  let is_main = opt_obj.is_main;
  let rs_smenu_arr: SubMenuRow[] = [];

  //위치변경
  let change_smenu_arr = [...smenu];
  for (let i = 0; i < change_smenu_arr.length; i++) {
    let tmp_smenu = { ...change_smenu_arr[i] };
    if (comp_sort_detail == "plani") {
      if (strFunc.str_in_array(tmp_smenu.key, smenu_plani_except_arr) != -1) {
        tmp_smenu.isShow = false;
      }
    } else if (comp_sort_detail == "sntbr") {
      if (strFunc.str_in_array(tmp_smenu.key, smenu_sntbr_except_arr) != -1) {
        tmp_smenu.isShow = false;
      }
    } else if (comp_sort_detail == "growple") {
      if (tmp_smenu.key == "study_title_list_union") {
        tmp_smenu.name = "우리학원교재";
        tmp_smenu.hmenu = "h_lecture";
      }
      let tmp_smenu_growple_except_arr = [];
      for (let si = 0; si < smenu_growple_except_arr.length; si++) {
        if (user.is_use_coon_en == "1") {
          if (smenu_growple_except_arr[si] == "coolen_move") {
            continue;
          }
        }
        if (user.is_use_math == "1") {
          if (smenu_growple_except_arr[si] == "plan_math_main") {
            continue;
          }
        }
        tmp_smenu_growple_except_arr.push(smenu_growple_except_arr[si]);
      }
      if (strFunc.str_in_array(tmp_smenu.key, tmp_smenu_growple_except_arr) != -1) {
        tmp_smenu.isShow = false;
      }
    }

    if (tmp_smenu.key == "site_map") {
      if (user.comp_seq == "4") {
        tmp_smenu.isShow = true;
      }
    }
    //성정관
    if (user.comp_seq == "8") {
      if (tmp_smenu.key == "desk_main") {
        tmp_smenu.isShow = true;
      }
    }

    change_smenu_arr[i] = tmp_smenu;
  }

  for (let i = 0; i < change_smenu_arr.length; i++) {
    let item = { ...change_smenu_arr[i] };
    let is_able = true;
    if (item.isShow == false) {
      //is_able = false;
    }

    if (user_grade != "master") {
      if (strFunc.str_in_array(item.key, smenu_master_arr) != -1) {
        is_able = false;
      }
    }
    if (is_main) {
      if (strFunc.str_in_array(item.key, smenu_main_key_arr) != -1) {
        is_able = true;
        item.isShow = true;
      }
    }
    if (is_able) {
      rs_smenu_arr.push(item);
    }
  }
  return rs_smenu_arr;
};
export const get_now_smenu = (inData: any) => {
  let opt_obj = {
    url: window.location.pathname,
    user_grade: "",
    comp_sort_detail: "",//plani
    user: {},
    is_main: false,
    ...inData
  };
  let url = opt_obj.url;
  let now_smenu: any = null;
  let smenu_arr: SubMenuRow[] = get_smenu_arr(opt_obj);

  for (let i = 0; i < smenu_arr.length; i++) {
    let item = smenu_arr[i];
    if (item.url == url) {
      now_smenu = item;
    }
  }

  if (now_smenu && now_smenu.first_subkey) {
    for (let i = 0; i < smenu_arr.length; i++) {
      let item = smenu_arr[i];
      if (item.key == now_smenu.first_subkey) {
        now_smenu = item;
      }
    }
  }
  return now_smenu;
};